<template>
  <div class="newsListItem">
    <div class="head">
      <img v-if="imgShow" src="../../assets/img/news/head-list.png" />
      <img v-else src="../../assets/img/news/head-list-y.png" />
    </div>
    <div class="contents">
      <div class="contents-head">{{ newsList.title }}</div>
      <div class="contents-time">
        {{ $t("i18n.Releasetime") }}：{{ newsList.create_time_text }}
      </div>
      <div class="contents-box" v-if="newsList.contentBase">
        <div v-html="newsList.contentBase.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsListItem",
  data() {
    return {
      newsList: {},
      imgShow: true,
    };
  },
  created() {
    if (localStorage.getItem("Language") == "zh-cn") {
      this.imgShow = true;
    } else {
      this.imgShow = false;
    }
    this.getNews();
  },
  methods: {
    async getNews() {
      const { data: data } = await this.$http.get("detail", {
        params: {
          id: this.$route.query.id,
          lang: localStorage.getItem("Language"), //切换中英文
        },
      });
      this.newsList = data.data;
    },
  },
};
</script>
<style lang="less" scoped>
.newsListItem {
  .head {
    width: 100%;
    height: 116px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .contents {
    padding: 0 190px;
    min-height: 500px;
    .contents-head {
      margin: 15px 0 25px 0;
      font-size: 22px;
      color: #000;
    }

    .contents-time {
      color: #bcbcbc;
      font-size: 14px;
      margin-bottom: 40px;
    }

    .contents-box {
      padding: 25px 52px;
      background-color: #f5f5f5;
      margin-bottom: 50px;
      line-height: 2;
    }
  }
}
</style>
